// src/Lexburner/Lexburner.jsx

import React, { useState, useEffect } from "react";
import AngelWrapper from "./angel3";       // 你的 3D 背景 Wrapper
import PhoneInput, { getCountryCallingCode } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Phone, Users, User, ArrowLeft } from "lucide-react";
import "./Lexburner.css";
import { FiPhoneCall, FiUsers, FiFileText } from 'react-icons/fi';
import { FiSearch, FiUser } from "react-icons/fi";
import MyStuff from "./MyStuff";

export default function Lexburner({ summaryItems }) {
  const [phone, setPhone] = useState("");         // 完整国际格式
  const [rawNumber, setRawNumber] = useState(""); // 只存拨号键盘输入
  const [active, setActive] = useState("dialer");

    const [contactName, setContactName] = useState("");
  const [country, setCountry] = useState("US");
  const [contactPhone, setContactPhone] = useState("");


 const [contacts] = useState([
   { id: 1, name: "Alice Zhang", phone: "+1 415-555-0123" },
   { id: 2, name: "Bob Li",     phone: "+1 212-555-0456" },
   { id: 3, name: "Carol Wang", phone: "+1 310-555-0789" },
 ]);
  const [query, setQuery] = useState("");

  // 语音播报
  useEffect(() => {
    if (summaryItems?.length) {
      const u = new SpeechSynthesisUtterance(summaryItems.join("，"));
      window.speechSynthesis.speak(u);
    }
  }, [summaryItems]);

  const tabs = [
    { key: 'dialer',   Icon: FiPhoneCall, label: 'Burner Call' },
    { key: 'contacts', Icon: FiUsers,     label: 'Contacts'   },
    { key: 'notes',    Icon: FiFileText,  label: 'My Stuff'   },
  ];

  const keys = ["1","2","3","4","5","6","7","8","9","0","*","#"];

  const handleDigit = k => {
    setRawNumber(n => n + k);
    const digits = (rawNumber + k).replace(/[^\d]/g, "");
    setPhone(digits ? "+" + digits : "");
  };

  const handleDelete = () => {
    const newRaw = rawNumber.slice(0, -1);
    setRawNumber(newRaw);
    const digits = newRaw.replace(/[^\d]/g, "");
    setPhone(digits ? "+" + digits : "");
  };

  const handleCall = () => {
    alert(`Calling: ${phone}`);
    // TODO: 真正呼叫逻辑
  };

  // 添加联系人  
  const handleAddContact = () => {
    console.log("Add contact:", { contactName, country, contactPhone });
    // TODO: 调用 API 保存
    setContactName("");
    setCountry("US");
    setContactPhone("");
  };

  return (
    <AngelWrapper>
      <div className="lexburner">
        {active === "dialer" && (
          <div className="dialer-ui">
            {/* —— 头部：输入框 + 删除箭头 + 拨号按钮 —— */}
            <div className="dialer-header">
              <PhoneInput
                international
                defaultCountry="US"
                placeholder="Enter phone number"
                value={phone}
                onChange={setPhone}
                className="phone-input"
              />
              <button className="delete-btn" onClick={handleDelete}>
                <ArrowLeft size={24} />
              </button>
              <button className="call-btn-header" onClick={handleCall}>
                <Phone size={24} />
              </button>
            </div>

            {/* —— 六列拨号键 —— */}
            <div className="dialer-grid">
              {keys.map(k => (
                <button
                  key={k}
                  className="dialer-key"
                  onClick={() => handleDigit(k)}
                >
                  {k}
                </button>
              ))}
            </div>
          </div>
        )}

           {active === "contacts" && (
  <div className="contacts-form-page">


    {/* Name */}
    <label className="form-label">Name</label>
    <input
      type="text"
      className="form-input"
      placeholder="Add or search"
      value={contactName}
      onChange={e => setContactName(e.target.value)}
    />

    {/* Phone (合并 Country code + Local) */}
    <label className="form-label">Phone</label>
    <PhoneInput
      international
      defaultCountry={country}
      value={contactPhone}
      onChange={value => setContactPhone(value)}
      className="form-input"
    />

    {/* Add Button */}
    <button
      className="btn-add"
      onClick={handleAddContact}
      disabled={!contactName || !contactPhone}
    >
      +
    </button>

    {/* Add 之后在下方列出联系人 */}
    {contacts.length > 0 && (
      <ul className="contact-list">
        {contacts.map(c => (
          <li key={c.id} className="contact-item">
            <span>{c.name}</span>
            <span>{c.phone}</span>
          </li>
        ))}
      </ul>
    )}
  </div>
)}


     {active === "notes" && <MyStuff />}

        {/*—— 底部 Dock ——*/}
        <div className="gallery-dock">
          {tabs.map(({ key, Icon, label }) => (
            <div
              key={key}
              className={`dock-item${active === key ? " active" : ""}`}
              onClick={() => setActive(key)}
            >
              <Icon size={24} />
              <span className="dock-label">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </AngelWrapper>
  );
}
